import { Theme } from "@mui/material";
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  statusText: {
    whiteSpace: 'nowrap',
    margin: `0px ${theme.spacing(1)}px`,
  },
}));
